module.exports = __webpack_public_path__ + "img/warning.390ec055.svg";